<button mat-icon-button>
  <mat-icon> close </mat-icon>
</button>
